import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { NoteEntite } from '../entites/note';

@Injectable({ providedIn: 'root' })
export class NoteService {

  private obtenirListeUrl = environment.apiBaseUrl + 'note';
  private obtenirListeParItemUrl = environment.apiBaseUrl + 'note/item/{id}';
  private obtenirUrl = environment.apiBaseUrl + 'note/{id}';
  private ajouterUrl = environment.apiBaseUrl + 'note';
  private modifierUrl = environment.apiBaseUrl + 'note/modifier';
  private supprimerUrl = environment.apiBaseUrl + 'note/{id}';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router) { }

  public ObtenirListe(): Promise<ReponseBase<NoteEntite[]>> {
    var p = this.http.get<ReponseBase<NoteEntite[]>>(this.obtenirListeUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirListeParItem(id: number): Promise<ReponseBase<NoteEntite[]>> {
    var p = this.http.get<ReponseBase<NoteEntite[]>>(this.obtenirListeParItemUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Obtenir(id: number): Promise<ReponseBase<NoteEntite>> {
    var p = this.http.get<ReponseBase<NoteEntite>>(this.obtenirUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Ajouter(note: NoteEntite): Promise<ReponseBase<NoteEntite>> {
    var p = this.http.post<ReponseBase<NoteEntite>>(this.ajouterUrl, JSON.stringify(note), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Modifier(note: NoteEntite): Promise<ReponseBase<NoteEntite>> {
    var p = this.http.post<ReponseBase<NoteEntite>>(this.modifierUrl, JSON.stringify(note), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Supprimer(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}
